var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelivered = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.463,
    height: 15.562,
    viewBox: "0 0 21.463 15.562",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.371,69.683V65.618A1.62,1.62,0,0,0,13.753,64H1.618A1.62,1.62,0,0,0,0,65.618v8.09a1.62,1.62,0,0,0,1.618,1.618h9.071a4.448,4.448,0,1,0,4.681-5.642ZM1.618,64.809H13.753c.017,0,.031.009.048.01L8.018,69.565a.683.683,0,0,1-.638.021L1.571,64.819C1.587,64.818,1.6,64.809,1.618,64.809Zm8.919,9.708H1.618a.81.81,0,0,1-.809-.809v-8.09A.8.8,0,0,1,.877,65.3L6.9,70.237a1.423,1.423,0,0,0,1.539.017.392.392,0,0,0,.065-.044L14.493,65.3a.8.8,0,0,1,.069.322v4.065a4.454,4.454,0,0,0-4.045,4.429C10.517,74.249,10.525,74.383,10.537,74.517Zm4.429,3.236a3.64,3.64,0,1,1,3.64-3.64A3.644,3.644,0,0,1,14.966,77.753Z",
    transform: "translate(0 -64)",
    fill: "#019643",
    stroke: "#019643",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.809,2.358,1.138.4A.4.4,0,1,0,.329.4L0,2.525a.4.4,0,0,0,.118.286L7.468,4.264a.4.4,0,1,0,.572-.572Z",
    transform: "translate(12.406 10.422) rotate(-60)",
    fill: "#019643",
    stroke: "#019643",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelivered, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delivered.535cb41f.svg";
export { ForwardRef as ReactComponent };